<section class="cmn-innerpage-wrapper accommodation">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>

    <div class="form-wrapper" style="padding-top: 10px">
      <form [formGroup]="monthForm">
        <div class="form-wrapper">
          <mat-form-field appearance="fill">
            <mat-label>Choose Month</mat-label>
            <mat-select formControlName="month">
              <mat-option *ngFor="let month of months" [value]="month.value">
                {{ month.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <div class="accommodation-rent-title">
    <div class="cmn-title">Accommodation Monthly Rent Summary</div>
    <div class="rent-details">
      <p>Property : <span>{{propertyName ? propertyName : '--'}}</span></p>
      <p>Total Rent : 
        <span>
          {{ totalAmount !== undefined && totalAmount !== null 
              ? ('AED ' + totalAmount.toFixed(2)) 
              : '--' }}
        </span>
      </p>      
    </div>
  </div>
  <div class="inner-content">
    <ag-grid-angular
      style="width: 100%"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [suppressRowClickSelection]="true"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [class]="themeClass"
    />
  </div>
</section>
